import { CART_GROUP_TYPE_PRODUCT, CartGroup, CartItem, SampleServiceItem } from '../../model/cart.model';
import { SampleTypeSamplingItem } from '../../model/group-sampling-items.model';
import { CatalogueItem } from '../../model/catalogue-category/catalogue-item.model';
import { Price } from '../../model/catalogue-category/price.model';
import { CartConstants } from '../../constants/application-constants';

export const orderGroupItemsFn = (groups) => [...groups].sort((x, y) => y.resourceType === 'product-cart-item-group.v1' ? -1 : 0);

export const orderCartItemsFn = groups => groups.map((group: CartGroup) => {
    const g: CartGroup = group.clone();
    const sampleServices = !g.labServices ? [] : g.labServices.filter(item => item instanceof SampleServiceItem);
    const otherItems = g.items.filter(item => !(item instanceof SampleServiceItem));
    g.items = [...sampleServices, ...otherItems];
    return g;
});

export const createAestheticSupplyCartGroup = (items: CartItem[], name = CartConstants.SAMPLING_SUPPLIES_GROUP_NAME) => {
    const newGroup = new CartGroup((new Date()).getTime(), name);
    newGroup.resourceType = CART_GROUP_TYPE_PRODUCT;
    const aestheticItems = items.map(item => {
        const newItem = item.clone();
        newItem.quantity = newItem.autoPopulatedQty;
        newItem.quantityPrice = new Price(newItem.quantity * newItem.item.price.amount, item.quantityPrice.currency); ;

        return newItem;
    });

    const price = new Price(aestheticItems.reduce(getItemsSumPrice, 0), CartConstants.CURRENCY);

    newGroup.groupPrice = price;
    newGroup.items = aestheticItems;
    newGroup.unavailableItems = [];

    return newGroup;
};

const getItemsSumPrice = (sum, t: CartItem) => sum + t.quantity * t.item.price.amount;

export const getCollectionIds = (key, collection) => collection.map(t => t[key]);

export const sumGroupsPrices = (groups: CartGroup[]) => groups.reduce(
    (sum, group) => {
        if (group && group.groupPrice && group.groupPrice.amount) {
            return sum + group.groupPrice.amount;
        }
        return sum;
    }, 0);


export const trimCartItems = (items: CartItem[]): CartItem[] => items.reduce((s, t) => {
    const exists = s.some((t1: CartItem) => t1.item.id === t.item.id);
    return exists ? s : [ ...s, t ];
}, []);

export const cartHasServiceItemsOnly = (supplies, services) => {
    const hasSupplyItem = supplies.length > 0;
    const hasServiceItem = services.length > 0;
    return !hasSupplyItem && hasServiceItem;
};
